(function(){
  'use strict';

  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true}); else fn(); }
  function norm(value){
    return String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim();
  }

  /* V103: one authoritative scroll target for the real technical section. */
  function technicalTarget(){
    return document.querySelector('.mg2-pdp-tech--v6[data-mg2-pdp-tech]') || document.querySelector('#mg2-product-technical.mg2-pdp-tech--v6');
  }
  function scrollToTechnical(event){
    var link=event.target && event.target.closest ? event.target.closest('a[href="#mg2-product-technical"], [data-mg2-scroll-specs]') : null;
    if(!link) return;
    var target=technicalTarget();
    if(!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    target.style.setProperty('content-visibility','visible','important');
    target.style.setProperty('contain-intrinsic-size','auto','important');
    function destination(){
      var header=document.querySelector('[data-mg2-header]');
      var headerHeight=header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      var anchor=target.querySelector('.mg2-pdp-tech__head') || target;
      return Math.max(0, window.scrollY + anchor.getBoundingClientRect().top - Math.max(20,headerHeight+20));
    }
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        window.scrollTo({top:destination(),behavior:'smooth'});
        try{ history.replaceState(null,'','#mg2-product-technical'); }catch(e){}
        window.setTimeout(function(){
          var y=destination();
          if(Math.abs(window.scrollY-y)>12) window.scrollTo({top:y,behavior:'auto'});
        },700);
      });
    });
  }

  /* V110: variant-aware Color + Size matching without fighting Shopify's
     server-side result set. Shopify remains the source of truth for the list.
     We only hide a returned product when BOTH Color and Size are selected and
     no single variant actually has that exact combination. A color-only filter
     must never blank a server result page because storefront/filter labels can
     differ from the literal option text (Amarillo vs Yellow, etc.). */
  function selectedFacetValues(root){
    var groups={color:[],size:[]};
    var form=root && root.querySelector('[data-lbx-filter-form]');
    if(!form) return groups;
    form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function(input){
      var details=input.closest('.lbxv5-filter');
      var label=details && details.querySelector('summary span') ? details.querySelector('summary span').textContent : '';
      var key=norm(label+' '+(input.name||''));
      var value=String(input.value||'').trim();
      if(!value) return;
      if(/color|colour|farbe|couleur|colore|\bcor\b|kleur/.test(key)) groups.color.push(value);
      if(/talla|size|taille|taglia|maat|tamanho|frame|cuadro|rahmen|grosse|große/.test(key)) groups.size.push(value);
    });
    groups.color=Array.from(new Set(groups.color.map(norm))).filter(Boolean);
    groups.size=Array.from(new Set(groups.size.map(norm))).filter(Boolean);
    return groups;
  }
  function parseMatrix(card){
    var script=card.querySelector('[data-lbx-v103-variants]');
    if(!script) return null;
    try{return JSON.parse(script.textContent||'{}');}catch(e){return null;}
  }
  function canonicalColorTokens(value){
    var n=' '+norm(value)+' ';
    var out=[];
    var aliases={
      black:[' negro ',' black ',' schwarz ',' noir ',' nero ',' preto ',' zwart '],
      white:[' blanco ',' blanca ',' white ',' weiss ',' weiß ',' blanc ',' bianco ',' branco ',' wit '],
      gray:[' gris ',' grey ',' gray ',' grau ',' grigio ',' cinza ',' silver ',' plata ',' argent '],
      blue:[' azul ',' blue ',' blau ',' bleu ',' blu ',' azul marino ',' navy '],
      green:[' verde ',' green ',' grun ',' gruen ',' grün ',' vert ',' verde oliva ',' olive '],
      red:[' rojo ',' roja ',' red ',' rot ',' rouge ',' rosso ',' vermelho ',' burdeos ',' burgundy '],
      beige:[' beige ',' arena ',' sand ',' cream ',' crema ',' creme ',' ivoire ',' ivory ',' champan ',' champagne '],
      brown:[' marron ',' marrón ',' brown ',' braun ',' brun ',' marrone ',' castano ',' café ',' cafe '],
      orange:[' naranja ',' orange ',' arancione ',' laranja '],
      yellow:[' amarillo ',' amarilla ',' yellow ',' gelb ',' jaune ',' giallo ',' mostaza ',' mustard ',' limon ',' limón '],
      purple:[' morado ',' morada ',' purple ',' violeta ',' violet ',' lila ',' lilac ',' aubergine '],
      pink:[' rosa ',' pink ',' rose ',' rosa palo ',' fucsia ',' fuchsia '],
      gold:[' dorado ',' dorada ',' gold ',' golden ',' oro ']
    };
    Object.keys(aliases).forEach(function(key){
      if(aliases[key].some(function(alias){return n.indexOf(alias)!==-1;})) out.push(key);
    });
    if(!out.length){
      var plain=norm(value);
      if(plain)out.push(plain);
    }
    return Array.from(new Set(out));
  }
  function colorMatches(value,selected){
    if(!selected.length) return true;
    var valueTokens=canonicalColorTokens(value);
    var selectedTokens=[];
    selected.forEach(function(item){selectedTokens=selectedTokens.concat(canonicalColorTokens(item));});
    return valueTokens.some(function(token){return selectedTokens.indexOf(token)!==-1;});
  }
  function optionMatches(value, selected, kind){
    if(!selected.length) return true;
    if(kind==='color') return colorMatches(value,selected);
    var n=norm(value);
    return selected.indexOf(n)!==-1;
  }
  function matchingVariants(matrix, groups){
    var cp=Number(matrix.colorPosition||0), sp=Number(matrix.sizePosition||0);
    return (matrix.variants||[]).filter(function(v){
      var options=Array.isArray(v.options)?v.options:[];
      var colorOK=!groups.color.length || !cp || optionMatches(options[cp-1],groups.color,'color');
      var sizeOK=!groups.size.length || !sp || optionMatches(options[sp-1],groups.size,'size');
      return colorOK && sizeOK;
    });
  }
  function resetComboHidden(card){
    if(card.getAttribute('data-lbx-v103-combo-hidden')==='1'){
      card.removeAttribute('data-lbx-v103-combo-hidden');
      if(!card.classList.contains('lbxv87-offer-hidden'))card.hidden=false;
    }
  }
  function setCandidate(card,candidate){
    if(!candidate)return;
    if(candidate.image){
      var image=card.querySelector('.lbx-canon-card__image');
      if(image){
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src=candidate.image;
      }
    }
    if(candidate.id){
      card.querySelectorAll('a[href*="/products/"]').forEach(function(a){
        try{
          var u=new URL(a.href,location.origin);
          u.searchParams.set('variant',candidate.id);
          a.href=u.pathname+u.search+u.hash;
        }catch(e){}
      });
    }
  }
  function updateCardForVariant(card, matrix, groups){
    var cp=Number(matrix.colorPosition||0), sp=Number(matrix.sizePosition||0);
    var hasColor=!!(groups.color.length && cp);
    var hasSize=!!(groups.size.length && sp);
    var enforceExactCombo=hasColor && hasSize;

    /* Important: a color-only or size-only filter has already been resolved by
       Shopify. Do not second-guess/hide those products client-side. */
    if(!enforceExactCombo) resetComboHidden(card);

    var matches=matchingVariants(matrix,groups);
    if(enforceExactCombo && !matches.length){
      /* V119: retain the paginated card, but do not imply this exact
         size+color exists. Post-pagination hiding created sparse pages. */
      card.setAttribute('data-lbx-v119-combo-unavailable','1');
      resetComboHidden(card);
      return;
    }
    card.removeAttribute('data-lbx-v119-combo-unavailable');
    if(enforceExactCombo) resetComboHidden(card);

    /* Use the selected color's variant image whenever we can. This works even
       if the filter label is translated differently from the variant option. */
    var candidate=null;
    if(hasColor){
      candidate=matches.find(function(v){return v.available && v.image;}) ||
        matches.find(function(v){return v.image;}) || matches[0];
      if(!candidate){
        candidate=(matrix.variants||[]).find(function(v){
          var options=Array.isArray(v.options)?v.options:[];
          return colorMatches(options[cp-1],groups.color) && v.image;
        }) || null;
      }
    }else if(enforceExactCombo){
      candidate=matches.find(function(v){return v.available && v.image;}) || matches.find(function(v){return v.image;}) || matches[0];
    }
    setCandidate(card,candidate);
  }
  function syncVariantFilteredCount(root,groups){
    /* Never replace the global server count with the length of one page. */
    var count=root.querySelector('.lbxv5-toolbar p strong');
    var serverCount=root.getAttribute('data-lbx-server-count');
    if(count && serverCount!==null)count.textContent=serverCount;
  }
  function syncVariantEmptyState(root,groups){
    var old=root.querySelector('[data-lbx-v110-variant-empty]');
    if(old)old.remove();
    /* Shopify renders the canonical empty state before pagination. */
  }

  function applyVariantFacetLogic(){
    var root=document.querySelector('[data-lbx-catalog]');
    if(!root) return;
    var count=root.querySelector('.lbxv5-toolbar p strong');
    /* Every invocation follows a server/AJAX list render (or a real list
       mutation), so refresh the authoritative count instead of keeping the
       first page's stale value forever. */
    if(count)root.setAttribute('data-lbx-server-count',String(count.textContent||'').trim());
    var groups=selectedFacetValues(root);
    root.querySelectorAll('[data-lbx-product-card]').forEach(function(card){
      var matrix=parseMatrix(card);
      if(matrix) updateCardForVariant(card,matrix,groups);
    });
    syncVariantFilteredCount(root,groups);
    syncVariantEmptyState(root,groups);
  }
  function observeCatalog(){
    var root=document.querySelector('[data-lbx-catalog]');
    if(!root) return;
    applyVariantFacetLogic();
    var list=root.querySelector('[data-lbx-product-list]');
    if(!list || list.__lbxV103Observer) return;
    list.__lbxV103Observer=true;
    var timer=0;
    new MutationObserver(function(){
      clearTimeout(timer);
      timer=setTimeout(applyVariantFacetLogic,30);
    }).observe(list,{childList:true,subtree:false});
  }

  document.addEventListener('click',scrollToTechnical,true);
  ready(function(){ observeCatalog(); });
  document.addEventListener('shopify:section:load',function(){ observeCatalog(); });
  document.addEventListener('lbx:catalog-updated',function(){ observeCatalog(); });
})();
